import { formatEasternTimeFirstDateTime } from '../formatters';

const stageMap: Record<string, string> = {
  AlphaTest: 'Alpha Test',
  'Waiting on us': 'Waiting on Us',
};

export function formatDateTimeWithTimeFirst(date: Date | null) {
  return formatEasternTimeFirstDateTime(date);
}

const HUBSPOT_TICKET_URL_PREFIX =
  'https://app-na2.hubspot.com/contacts/22812690/record/0-5';

export function getHubspotTicketUrl(hubspotId: string) {
  return `${HUBSPOT_TICKET_URL_PREFIX}/${hubspotId}`;
}

export function formatStageName(stage: string) {
  return stageMap[stage] || stage;
}

const HUBSPOT_STATUS_BADGE_CLASSES: Record<string, string> = {
  NotSubmitted: 'bg-neutral-500/10 text-neutral-400 border-neutral-500/20',
  Submitted: 'bg-blue-500/10 text-blue-400 border-blue-500/20',
  UnderReview: 'bg-yellow-500/10 text-yellow-400 border-yellow-500/20',
  AlphaTest: 'bg-purple-500/10 text-purple-400 border-purple-500/20',
  Approved: 'bg-green-500/10 text-green-400 border-green-500/20',
  Rejected: 'bg-red-500/10 text-red-400 border-red-500/20',
  RequiresChanges: 'bg-orange-500/10 text-orange-400 border-orange-500/20',
  ProcessingFailed: 'bg-red-600/10 text-red-500 border-red-600/20',
  Error: 'bg-red-500/20 text-red-400 border-red-500/30',
};

export function getHubspotStatusBadgeColor(
  status: string,
  stage: string | null | undefined,
) {
  const normalizedStatus = status?.toLowerCase();
  const normalizedStage = stage?.toLowerCase();

  if (normalizedStatus === 'error' || normalizedStage === 'error') {
    return 'bg-red-500/20 text-red-400 border-red-500/30';
  }

  if (normalizedStage === 'processed' || normalizedStatus === 'processed') {
    return 'bg-cyan-500/10 text-cyan-400 border-cyan-500/20';
  }

  if (normalizedStage === 'complete' || normalizedStatus === 'complete') {
    return 'bg-emerald-500/10 text-emerald-400 border-emerald-500/20';
  }

  if (normalizedStage === 'closed' || normalizedStatus === 'closed') {
    return 'bg-slate-500/10 text-slate-400 border-slate-500/20';
  }

  return (
    HUBSPOT_STATUS_BADGE_CLASSES[status] ??
    'bg-neutral-500/10 text-neutral-300 border-neutral-500/20'
  );
}

/** Compact age for queue rows: "just now", "8m", "3h", "2d", then "Sep 3". */
export function formatTicketAge(date: Date, now = new Date()) {
  const minutes = Math.floor((now.getTime() - date.getTime()) / 60_000);

  if (minutes < 1) {
    return 'just now';
  }

  if (minutes < 60) {
    return `${minutes}m`;
  }

  const hours = Math.floor(minutes / 60);

  if (hours < 24) {
    return `${hours}h`;
  }

  const days = Math.floor(hours / 24);

  if (days < 7) {
    return `${days}d`;
  }

  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    ...(date.getFullYear() === now.getFullYear() ? {} : { year: 'numeric' }),
  });
}

export function getInitials(name: string) {
  return name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0])
    .join('')
    .toUpperCase();
}
